import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getLatestOrders, todaysOrdersUpdate } from '../../actions/LatestOrders';
import moment from 'moment';
import Spinner from '../Spinner';
import { useHistory } from 'react-router-dom';

const ucFirst = (str: string) =>
  str.split(' ').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');

const LatestOrders = ({ latestOrders, getLatestOrders, todaysOrdersUpdate }: any) => {
  const history = useHistory();

  useEffect(() => {
    getLatestOrders();
  }, []);

  const routeToOrder = (order: any) => {
    history.push({ pathname: `/adminpanel/orders/${order._id}` });
  };

  return (
    <div className="admin-card admin-card-scroll">
      <div className="admin-card-header">
        <p className="admin-card-title">Today&apos;s Orders</p>
        {latestOrders.orders.length > 0 && (
          <span className="admin-badge">{latestOrders.orders.length}</span>
        )}
      </div>

      <div className="admin-card-body admin-card-body-flush">
        {latestOrders.loading && (
          <div className="text-center py-4">
            <Spinner />
          </div>
        )}

        {!latestOrders.loading && latestOrders.orders.length === 0 && (
          <div className="admin-empty-state">
            <i className="fas fa-shopping-bag" />
            <p>No orders today</p>
          </div>
        )}

        {latestOrders.orders.length > 0 && (
          <div className="table-responsive">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Customer</th>
                  <th>Total</th>
                  <th>Status</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {latestOrders.orders.map((item: any) => (
                  <tr key={item._id} onClick={() => routeToOrder(item)}>
                    <td style={{ fontWeight: 600 }}>{ucFirst(item.firstName)} {ucFirst(item.lastName)}</td>
                    <td className="order-email">{item.email}</td>
                    <td>AUD {(item.total / 100).toFixed(2)}</td>
                    <td>
                      <span className={`status-badge ${item.orderStatus.toLowerCase()}`}>
                        {item.orderStatus}
                      </span>
                    </td>
                    <td className="order-time">{moment(item.created_at).fromNow()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  latestOrders: state.latestOrders,
});

export default connect(mapStateToProps, {
  getLatestOrders,
  todaysOrdersUpdate,
})(LatestOrders);
